import AppealResult from '@components/LocalMerchant/Appraise/AppealResult'

// 该页面目前还在用于申诉通知的页面跳转 action: appeal_failed
export default {
  path: 'AppealResult(/:id)',
  component: AppealResult,
  stat: '申诉/申诉结果'
}
